import React from "react";
import "./home.scss";
import Navbar from "../Section/Header/navbar.jsx";
import Banner from "../Section/Banner/banner.jsx";
import About from "../Section/secondhero/SecondHero.jsx";

import Finore from "../Section/Finore/Finore.jsx";
import Flashsale from "../Section/Promo/promo.jsx";
import Launching from "../Section/Soon/Csoon.jsx";
import Bellefont from "../Section/Bellefont/Bellefont.jsx";
import Promohut from "../Section/promohut/promoanniv.jsx";
import Promolist from "../Section/promolist/promolist.jsx";
import AP from "../Section/AP/AP.jsx";
import Residential from "../Section/Residential/Residential.jsx";
import AA1 from "../Section/AA/AA1.jsx";
import Apartemen from "../Section/Apartemen/Apartemen.jsx";
import AR from "../Section/AR/AR.jsx";
import Ruko from "../Section/Ruko/Ruko.jsx";
import Surrounding from "../Section/Surrounding/Surrounding.jsx";
import Lokasi from "../Section/Lokasi/lokasi.jsx";
import Footer from "../Section/Footer/Footer.jsx";
import Sales from "../Section/Sales/Sales.jsx";
import Scrolltohashelement from "../Pages/ScrollToHashElement";

import tombol from "../Media/tombol.webp";
const home = () => {
  const fungsiganteng = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281188083575&text=Halo%20Thobie,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Summarecon%20Serpong%20https://marketing-gadingserpong.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div className="home">
      <Scrolltohashelement />
      <Navbar />
      <Banner />
      <About />
      <Finore />
      <Flashsale />
      <Launching />
      <Bellefont />
      <Promohut />
      <Promolist />
      <AP />
      <Residential />
      <AA1 />
      <Apartemen />
      <AR />
      <Ruko />
      <Surrounding />
      <Lokasi />
      <Sales />
      <Footer />
      <img
        onClick={fungsiganteng}
        src={tombol}
        className="tombolwa"
        alt="Hubungi Sekarang!"
      />
    </div>
  );
};

export default home;
